import {
    convertUniversalDateToPersianDate,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoTableTitleContainer, RaikoCustomTable,
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    RaikoCustomSimpleChip,
    RaikoChipTypes, addNewRowToTable
} from "@moeindal/base-raiko-panel-components";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {ProjectService} from "../../serverService/projectService/ProjectService";
import Avatar from "@mui/material/Avatar";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useNavigate} from "react-router-dom";
import ProjectAddNew from "./ProjectAddNew";

export default function Projects() {

    let page = 0;
    const size = 20;

    const [numberOfItems, setNumberOfItems] = useState(0)
    const [projectsData, setProjectsData] = useState([])
    const [pageCount, setPageCount] = useState(0)
    const [loadingTable, setLoadingTable] = useState(false)

    const service = new ProjectService()
    useEffect(() => {
        if (typeof service !== 'undefined') {
            getProjectsListFromServer()
        }
    }, []);

    function tablePreparation(id, number, title, thumbnailUrl, authorInformation) {
        return {
            id: id,
            number: number,
            thumbnailUrl:
                <Avatar
                    variant="rounded"
                    alt="Remy Sharp"
                    src={thumbnailUrl}
                    sx={{width: 100, height: 50, justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center'}}/>,
            title: title,
            authorInformation: authorInformation,
        }
    }

    function getProjectsListFromServer() {
        setLoadingTable(true)
        service.getProjectsList(page, size).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setProjectsData([])
                response.data.map((item, index) => {
                    setProjectsData((prevState => [
                        ...prevState,
                        tablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.thumbnailUrl,
                            item.authorInformation,
                        )
                    ]))
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setLoadingTable(false)
        })

    }

    function handleAddNewProject() {

    }

    const navigate = useNavigate()

    function handleSelectRow(_item) {
        let _title = ""
        projectsData.map((item) => {
            if (item.id === _item)
                _title = item.title
        })

        navigate(
            RouteHelper.MagazineProjectsDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )
    }

    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    function handleAddNewItemToTable(item) {
        const newItems = addNewRowToTable(
            tablePreparation(
                item.id,
                1,
                item.title,
                item.thumbnailUrl,
                item.authorInformation,
            ),
            projectsData
        )


        setProjectsData(newItems)
        handleCloseDialog()
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.MagazineProjects.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن پروژه جدید"}
                dialogSize={DialogSize.LARGE}
            >
                <ProjectAddNew handleAddNewItemToTable={handleAddNewItemToTable}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.MagazineProjects.name, "")
                        ]}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                            <RaikoTableTitleContainer
                                title={"پروژه ها"}
                                amount={numberOfItems}
                                hasCreateNewItem={true}
                                createNewItemTitle={"افزودن"}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                data={projectsData}
                                pageCount={pageCount}
                                isLoading={loadingTable}
                                header={projectsColumns}
                                rowClicked={handleSelectRow}
                            />
                        </RaikoGridOneColumn>

                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>
    )
}
const projectsColumns = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'thumbnailUrl',
        label: 'نمایه',

    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'authorInformation',
        label: 'نویسنده',
    },
]
